import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Step, StepLabel, Stepper } from '@mui';

import './batch-upload-stepper.scss';

const STEPS = ['Upload file', 'Select fields', 'Edit'];

const BatchUploadStepper = ({ activeStep }) => (
  <div styleName="stepper">
    <Stepper activeStep={activeStep} orientation="vertical">
      {STEPS.map(label => (
        <Step key={label}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  </div>
);

BatchUploadStepper.propTypes = {
  activeStep: PropTypes.number
};

export default memo(BatchUploadStepper);
